<template>
    <div>
        <v-row justify="center" style="background-color: #0d2155;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <h1 class="text-h4 font-weight-light">
                                <LanguagePlaceholder is-html default-text="Redemption Summary" />
                            </h1>
                            <br />
                            <p class="general-text text-white">
                                <LanguagePlaceholder is-html default-text="
                                    In this report you will be able to see how many RISE rewards you have earned, total you have redeemed and the number of E-Vouchers within the selected incentive period.
                                    <br>
                                    <br>
                                    You will also have a summary of the RISE rewards you have earned over the last four incentive periods.
                                    " />
                            </p>
                        </div>
                    </v-container>

                    <v-row class="my-2">
                        <v-col cols="12" sm="6" md="4">
                            <div>
                                <v-select class="text-white" label="Select Incentive Period" v-model="selectedQuarter"
                                    :items="quarters" variant="outlined"
                                    aria-label="Select Incentive Period"></v-select>
                            </div>

                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <div>
                                <v-select class="text-white" label="Select Location" disabled
                                    variant="outlined"
                                    aria-label="Select Location"></v-select>
                            </div>

                        </v-col>
                    </v-row>



                </v-row>
                <v-row class="my-2"> 
                            <div>
                                <v-btn @click="clickSubmit" color="white" variant="outlined"><LanguagePlaceholder default-text="Submit" /></v-btn>
                            </div>
                    </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row no-gutters="" justify="center" style="background-color: #ffffff;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row justify="center">

                    <v-card color="#06599D" height="150" width="250" class="mx-2 my-6">
                        <v-card-text class="text-center pt-4">
                            <div class="text-white">
                                <div class="text-subtle-1 mb-6"><strong>Total Rewards Credited</strong></div>
                                <div class="general-heading">{{ $filters.currencyUSD(redemptionSummaryData.totalRewardsCredited) }}</div>
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card color="#06599D" height="150" width="250" class="mx-2 my-6">
                        <v-card-text class="text-center pt-4">
                            <div class="text-white">
                                <div class="text-subtle-1 mb-6"><strong>Rewards Redeemed</strong></div>
                                <div class="general-heading">{{ $filters.currencyUSD(redemptionSummaryData.totalRewardsRedeemed) }}</div>
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card color="#06599D" height="150" width="250" class="mx-2 my-6">
                        <v-card-text class="text-center pt-4">
                            <div class="text-white">
                                <div class="text-subtle-1 mb-2"><strong>Balance (zero'd out at the end of the quarter)</strong></div>
                                <div class="general-heading">{{ $filters.currencyUSD(redemptionSummaryData.balance) }}</div>
                            </div>
                        </v-card-text>
                    </v-card>


                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>

    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const cRes = ref([])




const systemStore = useSystemStore()

const selectedQuarter = ref('')
const quarters = ref([])

const redemptionSummaryData = ref({})

onMounted(() => {
    systemStore.getQuarters().then(result => {
    if (result.success) {
      quarters.value = result.quarters
        .filter(q => q.currentRedemptionQuarter === true || q.previousRedemptionQuarters === true)
        .map(q => q.quarter)
      
      selectedQuarter.value = result.quarters.find(q => q.currentRedemptionQuarter === true)?.quarter

      getData()
    }
    }).catch(error => {
      console.log('recalculateLocalValue', error)
    })
})



const getData = () => {
    systemStore.getRedemptionSummary(selectedQuarter.value).then(result => {
        redemptionSummaryData.value = result.redemptionSummary      
    })
}

const clickSubmit = () => {
    getData()
}
</script>